import { grey } from '@material-ui/core/colors';
import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles((theme) => {
  const styles: StyleRules = {
    root: {
      background: theme.palette.grey['100'],
      borderRadius: '4px',
      boxShadow: variables.shadows[1],
    },
    tabsRoot: {
      borderBottom: '1px solid #e8e8e8',
      background: '#fff',
    },
    tabsIndicator: {
      backgroundColor: '#192542',
      height: 3,
    },
    tabRoot: {
      color: '#818B9D',
      fontSize: 16,
      textTransform: 'initial',
      minWidth: 72,
      fontWeight: 400,
      '&:hover': {
        color: '#818B9D',
        opacity: 1,
      },
      ['&$tabSelected' as any]: {
        color: '#192542',
        fontWeight: 500,
      },
      '&:focus': {
        color: '#192542',
      },
      '& span': {
        fontSize: 16,
      },
    },
    tabSelected: {},
    typography: {
      padding: theme.spacing(1),
    },

    paper: {
      padding: '1.5rem',

      ['@media screen and (max-width: 600px)']: {
        padding: '0.5rem',
      },
    },

    inputsContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignContent: 'baseline',
      alignItems: 'flex-start',
      gap: '1rem',
    },

    buttonContainer: {
      ['@media screen and (min-width: 600px)']: {
        marginTop: 28,
      },

      ['@media screen and (max-width: 600px)']: {
        width: '100%',
      },
    },

    buttonNew: {
      maxHeight: '2.375rem',
      backgroundColor: '#0D2772',
      color: '#fff',
      '&:hover': {
        background: '#0d2772b8',
      },
      '&:disabled': {
        color: '#888',
        background: '#fff',
        border: '1px solid #ddd',
      },
    },
    buttonPostback: {
      border: '1px solid #ddd',
      background: '#fff',
      color: '#192542',
      maxHeight: '2.375rem',
      '&:hover': {
        background: '#ddd',
      },
      '&:disabled': {
        color: '#888',
        background: '#fff',
      },
    },
    buttonText: {
      fontSize: '1rem',
      textTransform: 'none',
    },
    control: {
      padding: '1rem 1.5rem 1rem 1.5rem',
      background: '#fff',
      borderRadius: '4px',
    },
    modalPostback: {
      padding: '1.5rem',
      width: '95vw',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      [theme.breakpoints.up('md')]: {
        width: 640,
      },
    },
    selectProduct: {
      background: '#fff',
    },
    statusAlert: {
      fontWeight: 400,
      marginTop: 10,
      fontSize: 14,
      lineHeight: '14px',
      '&.disapproved': {
        color: '#dc3f53',
      },
      '&.pending': {
        color: '#FECE3C',
      },
    },

    messageBlocked: {
      width: '100%',
      marginTop: theme.spacing(3),
      textAlign: 'center',
      color: grey[700],
      fontSize: 14,
    },
  };

  return styles;
});
